window.EDITORIAL = {
  "cities": [
    {
      "poster": "assets/editorial/cities-0.jpg",
      "video": "assets/editorial/cities-0.mp4"
    },
    {
      "poster": "assets/editorial/cities-1.jpg",
      "video": "assets/editorial/cities-1.mp4"
    },
    {
      "poster": "assets/editorial/cities-2.jpg",
      "video": "assets/editorial/cities-2.mp4"
    }
  ],
  "nature": [
    {
      "poster": "assets/editorial/nature-0.jpg",
      "video": "assets/editorial/nature-0.mp4"
    },
    {
      "poster": "assets/editorial/nature-1.jpg",
      "video": "assets/editorial/nature-1.mp4"
    },
    {
      "poster": "assets/editorial/nature-2.jpg",
      "video": "assets/editorial/nature-2.mp4"
    }
  ],
  "wildlife": [
    {
      "poster": "assets/editorial/wildlife-0.jpg",
      "video": "assets/editorial/wildlife-0.mp4"
    },
    {
      "poster": "assets/editorial/wildlife-1.jpg",
      "video": "assets/editorial/wildlife-1.mp4"
    },
    {
      "poster": "assets/editorial/wildlife-2.jpg",
      "video": "assets/editorial/wildlife-2.mp4"
    }
  ],
  "japan": [
    {
      "poster": "assets/editorial/japan-0.jpg",
      "video": "assets/editorial/japan-0.mp4"
    },
    {
      "poster": "assets/editorial/japan-1.jpg",
      "video": "assets/editorial/japan-1.mp4"
    },
    {
      "poster": "assets/editorial/japan-2.jpg",
      "video": "assets/editorial/japan-2.mp4"
    }
  ]
};
